<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :disabled="$attrs.readonly"
    persistent
    :return-value.sync="date"
    :width="width"
    v-bind="dialogProps"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        clearable
        :value="customTextFormat(date)"
        :label="label"
        :prepend-icon="icon"
        :readonly="textFieldReadonly"
        v-bind="{...attrs,...$attrs}"
        v-on="on"
        @click:clear="date = undefined"
      />
    </template>
    <v-date-picker
      v-model="date"
      full-width
      scrollable
      :locale="convertLocale(currentLocale, 'bcp47')"
      v-bind="datePickerProps"
    >
      <v-btn
        text
        color="primary"
        @click="modal = false"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="date = undefined"
      >
        {{ $t('common.clear') }}
      </v-btn>
      <v-spacer />

      <v-btn
        color="primary"
        @click="$refs.dialog.save(date)"
      >
        {{ $t('common.ok') }}
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
  components: {
  },
  props: {
    value: {
      validator: prop => typeof prop === 'string' || prop === null || prop === undefined,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '300px'
    },
    textFieldReadonly: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'mdi-calendar'
    },
    dialogProps: {
      type: Object,
      default: () => {}
    },
    datePickerProps: {
      type: Object,
      default: () => {}
    },
    customTextFormat: {
      type: Function,
      default: (date) => {
        if (date === null || date === undefined || date === '') return ''
        if (moment(date).isValid()) return moment(date).format('LL')
        else return ''
      }
    }
  },
  data () {
    return {
      modal: false,
      date: null
    }
  },
  watch: {
    value: {
      handler (val) {
        this.date = val
      },
      immediate: true
    },
    date (val) {
      this.$emit('input', val)
    }
  }
}
</script>
